// @wc-ignore-file
import type { Notification } from "./notifications.types";

export type DomainInviteFullTarget =
  | {
      to: "/workspaces/$slug/projects/$projectSlug/members";
      params: { slug: string; projectSlug: string };
    }
  | { to: "/workspaces/$slug/members"; params: { slug: string } };

/**
 * CR-185: where a domain_invite_full notification leads — the members page
 * that holds the invite's pill, so the owner can raise its maximum. A
 * workspace-level invite (or one covering several projects) has no project
 * slug, so this must run BEFORE resolveNotificationSlugs, which needs both.
 * Never the /invite/<code> link: the owner manages the invite, not joins it.
 * KEEP IN SYNC with resolveNotificationUrl in
 * backend/api-server/src/routes/notification-email-worker.ts.
 */
export function domainInviteFullTarget(
  notification: Pick<Notification, "workspace_slug" | "project_slug">,
): DomainInviteFullTarget | null {
  const { workspace_slug: slug, project_slug: projectSlug } = notification;
  if (!slug) return null;
  if (projectSlug) {
    return {
      to: "/workspaces/$slug/projects/$projectSlug/members",
      params: { slug, projectSlug },
    };
  }
  return { to: "/workspaces/$slug/members", params: { slug } };
}
